import {
  ContractsEmployeesContractVersionFragment,
  ContractsEmployeesJobCatalogContextlessPoliciesFragment,
  ContractsEmployeesReferenceContractFragment,
  JobCatalogTreeFragment,
} from 'generated/resources/graphql'

import PromoteFlowContent from './_PromoteFlowContent'

interface Props {
  contractVersion: ContractsEmployeesReferenceContractFragment
  jobCatalogTrees?: JobCatalogTreeFragment[]
  jobCatalogTreeFeatureEnabled?: boolean
  jobCatalogContextlessPolicies: ContractsEmployeesJobCatalogContextlessPoliciesFragment | undefined
  hasPayrollBundle: boolean
  contractVersions: ContractsEmployeesContractVersionFragment[]
}

const PromoteFlow = ({
  contractVersion,
  jobCatalogTrees,
  jobCatalogTreeFeatureEnabled,
  jobCatalogContextlessPolicies,
  hasPayrollBundle,
  contractVersions,
}: Props) => {
  return (
    <PromoteFlowContent
      jobCatalogTrees={jobCatalogTrees}
      jobCatalogTreeFeatureEnabled={jobCatalogTreeFeatureEnabled}
      contractVersion={contractVersion}
      contractVersions={contractVersions}
      jobCatalogContextlessPolicies={jobCatalogContextlessPolicies}
      hasPayrollBundle={hasPayrollBundle}
    />
  )
}

export default PromoteFlow
